import { createPortal } from "react-dom";
import PropTypes from "prop-types";

const Portal = ({ root, children }) => createPortal(children, root);

Portal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]).isRequired,
  root: PropTypes.instanceOf(Element).isRequired
};

export default Portal;
